<template class="d-flex flex-wrap pa-0">
    <div class="d-flex flex-wrap">
        <v-row no-gutters>
            <v-col cols="12" :sm="6" :md="3">
                <v-sheet class="border-md ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="90"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="6" :md="3">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="90"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="6" :md="3">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="90"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="6" :md="3">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="90"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="12" :md="8">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="250"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="12" :md="4">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="250"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
            <v-col cols="12" :sm="12" :md="12">
                <v-sheet class="ma-2">
                    <VueSkeletonLoader
                        type="rect"
                        :height="250"
                        :radius="7"
                        animation="fade"
                    />
                </v-sheet>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueSkeletonLoader from 'skeleton-loader-vue';
export default {
  components: { VueSkeletonLoader },
};
</script>